module.exports = __webpack_public_path__ + "img/icon_new_small.04a1f403.svg";